<script lang="ts" setup="">
import { type FatalError } from '@/store/global.ts'

const {
  error = {
    heading: 'Something went wrong',
    message: `We're sorry, but it looks like there was a problem with this page.
           Please click the button below retry or go back to the front page.`,
  },
} = defineProps<{ error?: FatalError }>()

function reload() {
  window.location.reload()
}
</script>

<template>
  <div class="v-application-error flex w-full items-center justify-center">
    <div class="mx-auto max-w-lg text-center">
      <slot name="title">
        <h1
          class="mb-4 text-headings-h2 font-bold"
          data-test="error-heading"
        >
          {{ error.heading }}
        </h1>
      </slot>
      <slot>
        <p
          class="mb-8"
          data-test="error-message"
        >
          {{ error.message }}
        </p>
      </slot>
      <slot name="actions">
        <div v-if="error.statusCode === 401">
          <VButton
            href="https://studyhub.novonordisk.com/get-access"
            variant="fill"
            data-test="get-access-button"
          >
            Get access
          </VButton>
        </div>
        <div
          v-else-if="error.statusCode !== 503"
          class="flex justify-center gap-2"
        >
          <VButton
            data-test="try-again-button"
            @click="reload"
          >
            Try again
          </VButton>
          <VButton
            href="/"
            variant="outlineSubtle"
            data-test="go-to-front-page-button"
          >
            Go to front page
          </VButton>
        </div>
      </slot>
      <div
        v-if="error.statusCode !== 401 && error.identifier"
        class="mt-8 text-body-small text-general-tertiary"
        data-test="correlation-id"
      >
        Correlation ID:
        {{ error.identifier }}
      </div>
    </div>
  </div>
</template>

<style>
.v-application-error {
  height: calc(100vh - 80px); /* Subtract VTopBar size */
}
</style>
